import AdditionalInfoTooltip from './AdditionalInfoTooltip';

export default AdditionalInfoTooltip;
